import { DateTime } from "luxon";
import { Col, Row } from "react-bootstrap";

import SiteAreaChart from "../../oversight-core/ui-elements/site-area-chart/site-area-chart";
import Helper from "../../oversight-core/utils/helpers";

interface IProps {
  data: { value: number; time?: number }[];
  value1?: number;
  value2?: number | string;
  stopColor: string;
  stroke: string;
  isBattery?: boolean;
  batteryStatus?: string;
  id: string;
  hide?: boolean;
  isShowTooltip?: boolean;
  zoneId?: string;
}

const SiteEnergySource = (props: IProps) => {
  const {
    data,
    value1,
    value2,
    stopColor,
    stroke,
    id,
    isBattery,
    batteryStatus,
    hide = true,
    isShowTooltip = true,
    zoneId,
  } = props;

  function formatEpochToDate(
    epochMillis: number,
    zoneId: string = "Africa/Nairobi",
  ): string {
    return DateTime.fromMillis(epochMillis)
      .setZone(zoneId)
      .toFormat("MMM dd, HH:mm");
  }

  const CustomTooltip = ({
    active,
    payload,
  }: {
    active?: boolean;
    payload?: { value: number; payload: { time: number } }[];
  }) => {
    if (active && payload && payload.length) {
      const { value, payload: dataPoint } = payload[0];
      const formattedTime = formatEpochToDate(dataPoint.time, zoneId);

      return (
        <Row className="bg-white p-1 shadow rounded-1">
          <Col>
            <Row>
              <Col className="text-dark-4 font-weight-500 font-size-14">{`${formattedTime}`}</Col>
            </Row>
            <Row>
              <Col className="text-light font-weight-400 font-size-14">{`${Number(
                Helper.roundTo2(Number(value)),
              )} ${isBattery ? `%` : `W`}`}</Col>
            </Row>
          </Col>
        </Row>
      );
    }
    return null;
  };

  return (
    <>
      {isBattery && (
        <Row className="mt-1">
          <Col className="text-light font-weight-400 font-size-8 text-center">
            {batteryStatus}
          </Col>
        </Row>
      )}
      {value1 ? (
        <Row>
          <Col className="text-light font-weight-400 font-size-12 text-center">
            {Number(Helper.roundTo2(value1))}
            {isBattery ? <>%&nbsp;|&nbsp;{value2}</> : <>&nbsp;W</>}
          </Col>
        </Row>
      ) : (
        <></>
      )}
      <SiteAreaChart
        data={data}
        stopColor={stopColor}
        stroke={stroke}
        id={id}
        hide={!value1 && hide}
        customTooltip={isShowTooltip ? <CustomTooltip /> : undefined}
      />
    </>
  );
};

export default SiteEnergySource;
